<template>
    <!-- Begin:PageContent-PromoBox -->
    <div class="global-map-area promo-box no-margin parallax" data-stellar-background-ratio="0.5">
        <div class="container">
            <div class="content-section description pull-right col-sm-9">
                <div class="table-wrapper hidden-table-sm">
                    <div class="table-cell">
                        <h1 class="m-title animated" data-animation-type="fadeInDown">
                            {{ promotext1[getCurrentLocale] }}<br />
                            <em>{{ promotext2[getCurrentLocale] }}</em>
                        </h1>
                    </div>
                    <div class="action-section table-cell">
                        <button class="btn-large animated sundairsrvcs" data-animation-type="bounce" data-animation-delay="0.5" onclick="window.location.href = '/services';">{{ booknowwithus[getCurrentLocale] }}</button>
                    </div>
                </div>
            </div>
            <div class="image-container col-sm-4">
                <img src="/res/images/shared/familie.png" alt="" width="" height="195" class="animated" data-animation-type="fadeInUp" />
            </div>
        </div>
    </div>
    <!-- End:PageContent-PromoBox -->
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                promotext1: {
                    en: 'Welcome to your FBR/Schauinsland',
                    de: 'Willkommen bei Ihrer FBR/Schauinsland',
                },
                promotext2: {
                    en: 'Where are you going on your next trip?',
                    de: 'Wohin geht Ihre nächste Reise?',
                },
                booknowwithus: {
                    en: 'Book now with us',
                    de: 'Buchen Sie jetzt bei uns',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>